import {Fragment} from "react";
import Header from "./header/header";
import Footer from "./footer/footer";
import ContactBlock from "./contact-block/contact-block";
import TableBlock from "./table-block/table-block";
import MainBlock from "./main-block/main-block";
import Works from "./works/works";
import MainBlock2 from "./main-block-2/main-block-2";
import PriceBlock from "./price-block/price-block";

function App() {
    return (
        <Fragment>
            <div className="bg1">
                <Header/>
                <MainBlock/>
                <Works />
            </div>

            <div className="bg2">
                <MainBlock2 />
                <TableBlock/>
            </div>

            <div className="bg3">
                <PriceBlock/>
                <ContactBlock/>
                <Footer/>
            </div>


        </Fragment>
    );
}

export default App;
